import { ReactNode, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionId, HOME_ID } from '@/shared/routes.ts';
import styles from './Section.module.scss';

const VIDEO_PLAYBACK_RATE = 0.8;

interface Props {
  id: SectionId;
  children?: ReactNode;
  video?: string;
}

const Section = ({ id, children, video }: Props) => {
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);

  const perex = t(`${id}.perex`, { defaultValue: '' });

  return (
    <section id={id} className={`${styles.section}${video ? ` ${styles.sectionWithVideo}` : ''}`}>
      {video && (
        <div className={styles.videoWrapper}>
          <video
            ref={videoRef}
            src={video}
            className={styles.video}
            autoPlay
            muted
            loop
            playsInline
            onCanPlay={() => {
              if (videoRef.current) videoRef.current.playbackRate = VIDEO_PLAYBACK_RATE;
            }}
          />
          <div className={styles.overlay} />
        </div>
      )}
      <div className={styles.container}>
        {id !== HOME_ID && (
          <header className={styles.sectionHeader}>
            <div className={styles.sectionHeadingGroup}>
              <p className={styles.sectionLabel}>{t(`${id}.heading`)}</p>
              <h2 className={styles.sectionTagline}>{t(`${id}.tagline`)}</h2>
            </div>
            {perex && <p className={styles.sectionPerex}>{perex}</p>}
          </header>
        )}
        {children}
      </div>
    </section>
  );
};

export default Section;
